var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"briefButler-icon",attrs:{"src":require("@/assets/icon/BriefButlerIcon.png"),"alt":"filterIcon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }